// type和初始值initialState
export interface IGetQuestions {
  isLoading: boolean;
  questions: any[];
  errors: string;
}

export type State = IGetQuestions;

export type IGetQuestionsStateAndAction = State & Action;
export type Action = {
  getReviewQuestion: () => void;
};

export const initialState: State = {
  isLoading: false,
  questions: [],
  errors: "",
};
